<template>
  <div>
    <Quiz />
  </div>
</template>

<script>
  import Quiz from '@/components/Quiz'

  export default {
    name: 'Home',

    components: {
      Quiz,
    },
  }
</script>
